var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1047_228836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9535 8.17266L21.8367 5.28945L13.7199 0.601562L11 3.32578L8.28003 0.601562L0.158936 5.28945L3.04214 8.17266L0.158936 11.0602L3.22261 12.8262V16.9039L11 21.3984L18.7773 16.9082V12.8305L21.841 11.0602L18.9535 8.17266ZM8.13823 1.67578L10.3039 3.84141L8.27144 5.01445L8.70112 5.75781L11.0042 4.42578L13.3074 5.75781L13.7371 5.01445L11.7046 3.84141L13.8617 1.67578L20.4402 5.47422L18.2746 7.63984L16.0402 6.35078L15.6105 7.09414L17.4839 8.17695L10.9957 11.9238L4.50737 8.17695L6.38081 7.09414L5.95112 6.35078L3.71675 7.63984L1.55112 5.47422L8.13823 1.67578ZM4.08198 13.3246L8.28003 15.748L10.0718 13.9562L9.46597 13.3504L8.14253 14.6738L1.55972 10.8754L3.72534 8.70977L10.5746 12.6629V20.1566L4.08198 16.4098V13.3246ZM17.9179 16.4098L11.4296 20.1566V12.6629L18.2789 8.70977L20.4445 10.8754L13.866 14.6738L12.4824 13.2902L11.8765 13.8961L13.7285 15.748L17.9265 13.3246V16.4098H17.9179Z",
    fill: "#4F5B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72351 5.90479L7.49378 5.46006L7.92346 6.20428L7.1532 6.649L6.72351 5.90479Z",
    fill: "#4F5B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0719 6.20166L14.5016 5.45744L15.2719 5.90217L14.8422 6.64639L14.0719 6.20166Z",
    fill: "#4F5B92"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1047_228836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.a60cac2d78ccd6281b999d370f176bfa.svg";
export { ForwardRef as ReactComponent };